/**
 * Возвращает уникальную хэш строку для объекта
 * @param data
 */
export const hash = (data) => {
    let resultHash = 0;
    const toHash = typeof data === 'string' ? data : JSON.stringify(data);
    if (toHash.length === 0) {
        return String(toHash);
    }
    for (let i = 0; i < toHash.length; i++) {
        let charCode = toHash.charCodeAt(i);
        resultHash = (resultHash << 7) - resultHash + charCode;
        resultHash = resultHash & resultHash;
    }
    return String(resultHash);
};
